import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

import { ADD_ON_IDS } from '@ctct/domain-layer';

export interface SelectedAddOn {
  id: string;
  option: string;
}

export interface IAddOnsSlice {
  selectedAddOns: SelectedAddOn[];
  includePurchased: boolean;
  preSelectedSmsOption: string | null;
  smsOptionsDialogOpen: boolean;
  // SMS bundle: controls visibility of the mobile tier-selection modal opened from "Edit add-on".
  smsBundleTierModalOpen: boolean;
}

export const createAddOnsSliceDefaultValues = (): IAddOnsSlice => ({
  selectedAddOns: [],
  includePurchased: true,
  preSelectedSmsOption: null,
  smsOptionsDialogOpen: false,
  smsBundleTierModalOpen: false,
});

export const createAddOnsSlice: StateCreator<IAddOnsSlice> = () => createAddOnsSliceDefaultValues();

export type AddOnsPageStore = UseBoundStore<StoreApi<IAddOnsSlice>>;

export const createAddOnsHooks = (pageStore: AddOnsPageStore) => {
  return {
    useSelectedAddOns: () => pageStore((state) => state.selectedAddOns),
    useSmsOptionsDialogOpen: () => pageStore((state) => state.smsOptionsDialogOpen),
    useIncludePurchased: () => pageStore((state) => state.includePurchased),
    usePreSelectedSmsOption: () => pageStore((state) => state.preSelectedSmsOption),
    useSelectedSmsBundleTier: (): string | null =>
      pageStore((state) => state.selectedAddOns.find((addOn) => addOn.id === ADD_ON_IDS.SMS)?.option ?? null),
    useSmsBundleTierModalOpen: () => pageStore((state) => state.smsBundleTierModalOpen),
  };
};

export type AddOnsHooks = ReturnType<typeof createAddOnsHooks>;
